/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import isNil from 'lodash.isnil';
import {translate} from '@ion/core/src/locale/locale';
import {GenericObject} from '@ion/core/src/types/entities';
import {TertiaryButton} from '@ion/dls/src/components/buttons/TertiaryButton';
import Divider from '@ion/dls/src/components/divider/Divider';

interface QueryOperationsProps {
  queryName: string;
  classes: GenericObject
  isNewQuery: boolean;
  savedQueryUpdated: boolean;
  onSaveChanges: () => void;
  onSaveNew: () => void;
  undoCurrentChanges: () => void;
  onRemove: () => void;
}

const SAVE_QUERY_ID = 'save-query';
const SAVE_AS_QUERY_ID = 'saveas-query';
const DELETE_QUERY_ID = 'delete-query';
const UNDO_QUERY_ID = 'undo-query';

export const Label = ({
  keyItem,
  classes,
  className,
  text = null
}: {
  keyItem: string,
  classes: GenericObject,
  className: string,
  text?: string
}) => (
  <span className={classes[className]}>
    {isNil(text) ? translate(`common:modularsearch.${keyItem}`) : text}

  </span>
);

export const QueryOperations = ({
  queryName,
  classes,
  isNewQuery,
  savedQueryUpdated,
  onSaveChanges,
  onSaveNew,
  undoCurrentChanges,
  onRemove
}: QueryOperationsProps) => {
  return (
    <>
      <MenuItem classes={{root: classes.menuItem}}>
        <TertiaryButton id={SAVE_QUERY_ID}
          disabled={!savedQueryUpdated}
          classes={{root: classes.labelRoot}}
          onClick={onSaveChanges}>
          <Label keyItem={'saveSearchChanges'}
            classes={classes}
            className={'saveText'} />
        </TertiaryButton>
      </MenuItem>
      <MenuItem classes={{root: classes.menuItem}}>
        <TertiaryButton id={SAVE_AS_QUERY_ID}
          disabled={!isNewQuery}
          classes={{root: classes.labelRoot}}
          onClick={onSaveNew}>
          <Label keyItem={'saveSearchAs'}
            classes={classes}
            className={'saveText'} />
        </TertiaryButton>
      </MenuItem>
      <MenuItem classes={{root: classes.menuItem}}>
        <TertiaryButton id={UNDO_QUERY_ID}
          disabled={!isNewQuery}
          classes={{root: classes.labelRoot}}
          onClick={undoCurrentChanges}>
          <Label keyItem={'undoChanges'}
            classes={classes}
            className={'undoChanges'} />
        </TertiaryButton>
      </MenuItem>
      <MenuItem classes={{root: classes.menuItem}}>
        <TertiaryButton id={DELETE_QUERY_ID}
          disabled={isNil(queryName)}
          classes={{root: classes.labelRoot}}
          onClick={onRemove}>
          <Label keyItem={'deleteSavedSearch'}
            classes={classes}
            className={'deleteSavedSearch'} />
        </TertiaryButton>
      </MenuItem>
      <Divider />
      <Divider />
    </>
  );
};
